module.exports = __webpack_public_path__ + "static/img/p22.ef7300c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p22.png
// module id = 5tPP
// module chunks = 1